const Prod_BaseUrl = process.env.REACT_APP_BACKEND_PROD_URL;
const Stage_BaseUrl = process.env.REACT_APP_BACKEND_STAGE_URL;

const environments = {
  production: Prod_BaseUrl,
  stage: Stage_BaseUrl,
  local: "http://192.168.3.209:8000",
};

const activeEnvironment = environments.production;

const apiUrl = {
  login: activeEnvironment + "/login",
  questions: activeEnvironment + "/get_questions",
  managers: activeEnvironment + "/manager_list",
  submitAnswers: activeEnvironment + "/save_answer_paper",
  verifyOtp: activeEnvironment + "/verify-candiate-otp",
  resendOtp: activeEnvironment + "/resend-candidate-otp",
  updateStatus: activeEnvironment + "/update-assessment-status",
};
export default apiUrl;
